function isEmpty(value) {
    if (value == null) {
        // 检查 null 或 undefined
        return true;
    }
    if (typeof value !== 'object') {
        // 检查非对象类型（如基本类型）
        return false;
    }
    if (Array.isArray(value) || isString(value)) {
        // 检查数组或字符串的长度
        return value.length === 0;
    }
    if (value instanceof Set || value instanceof Map) {
        // 检查 Set 或 Map 的大小
        return value.size === 0;
    }
    if (isPlainObject(value)) {
        // 检查普通对象的属性个数
        return Object.keys(value).length === 0;
    }
    return false;
}
function isString(value) {
    return typeof value === 'string';
}
function isPlainObject(value) {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

export { isEmpty };
